import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=87e6e35e&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"
import style0 from "./edit.vue?vue&type=style&index=0&id=87e6e35e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e6e35e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87e6e35e')) {
      api.createRecord('87e6e35e', component.options)
    } else {
      api.reload('87e6e35e', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=87e6e35e&scoped=true", function () {
      api.rerender('87e6e35e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/webSet/courseSet/edit.vue"
export default component.exports